import type { RestaurantMakeTime } from '~/types/api/data-contracts'

type MakeTimeRange = Pick<RestaurantMakeTime, 'minMinutes' | 'maxMinutes'> & {
  min?: number
  max?: number
}

function getMinMakeTimeMinutes(makeTime?: MakeTimeRange | null): number | undefined {
  return makeTime?.minMinutes ?? makeTime?.min
}

export function getMaxMakeTimeMinutes(makeTime?: MakeTimeRange | null): number | undefined {
  return makeTime?.maxMinutes ?? makeTime?.max
}

export function formatMakeTimeMessage(makeTime?: MakeTimeRange | null): string {
  const minMinutes = getMinMakeTimeMinutes(makeTime)
  const maxMinutes = getMaxMakeTimeMinutes(makeTime)

  if (minMinutes === undefined || maxMinutes === undefined || maxMinutes <= 0) {
    return ''
  }

  if (minMinutes === maxMinutes) {
    return `Ready in ${minMinutes} minutes`
  }

  return `Ready in ${minMinutes}-${maxMinutes} minutes`
}
